import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, Link } from 'react-router-dom';
import { useLoginMutation, useGoogleLoginMutation } from 'services/users';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { useGoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import { Button } from '@mui/material';


const LoginPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

const LoginFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
`;

const FormTitle = styled.h2`
  text-align: center;
  margin-bottom: 20px;
`;

const FormField = styled.input`
  padding: 8px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;

  &:focus {
    outline: none;
    border-color: #007bff;
  }
`;

const SubmitButton = styled.button`
  padding: 8px 16px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
`;

const LinksContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;

  a {
    text-decoration: none;
    color: #007bff;
  }

  a:hover {
    text-decoration: underline;
  }
`;


const LoginPage = () => {

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const { t } = useTranslation('auth');
  let navigate = useNavigate();

  const [login, { isSuccess, isError, error }] = useLoginMutation<any>();
  const [googleLogin, { isSuccess: isGoogleLoginSuccess, isError: isGoogleLoginError, error: googleLoginError }] = useGoogleLoginMutation<any>();

  const gLogin = useGoogleLogin({
    onSuccess: credentialResponse => {
      const token = credentialResponse.access_token;
      console.log("Google login response:", credentialResponse);
      console.log("Google login token:", token);
      if (token) {
        googleLogin({ token })
          .unwrap()
          .then(() => {
            navigate("/backoffice/", { replace: true });
          })
          .catch((error) => {
            toast.error("Google login failed. Please try again.");
          });
      }
    },
    onError: () => {
      toast.error("Google login failed. Please try again.");
    },
  });
  
  useEffect(() => {
    // Update the document title using the browser API
    if(isSuccess) {
      navigate("/backoffice/", { replace: true });
    }
  }, [isSuccess, navigate]);

  useEffect(() => {
    if(isError) {
      if (error && 'data' in error && (error.data as any)?.error_description) {
        toast.error((error.data as any)?.error_description);
        setPassword('');
      } else {
        toast.error("An error occurred. Please try again later.");
      };
    }
  }, [isError]);

  const submitLogin = () => {
    if (username && password) {
      login({ username, password });
    }
  }

  console.log("LoginPage rendered:", process.env.REACT_APP_GOOGLE_CLIENT_ID);
  return (
    <LoginPageContainer>
      <LoginFormContainer >
        <Button
          variant="contained"
          color="primary"
          onClick={() => gLogin()}
          style={{ marginBottom: '10px' }}
        >
          {t('auth.login_with_google')}
        </Button>
        <p style={{ textAlign: 'center', marginTop: '10px' }}>
          {t('auth.or_login_with')}
        </p>
        <FormTitle>Login</FormTitle>
        <FormField type="text" placeholder="Username" value={username} onChange={e => setUsername(e.target.value)}/>
        <FormField type="password" placeholder="Password" value={password}  onChange={e => setPassword(e.target.value)}/>
        <SubmitButton type="submit" onClick={submitLogin}>Login</SubmitButton>
        <LinksContainer>
          <Link to={'/sign-up/'}>Sign Up</Link>
          <Link to={'/forgot-password/'}>Forgot Password</Link>
        </LinksContainer>
      </LoginFormContainer>
    </LoginPageContainer>
  );
};

export default LoginPage;